<template>
  <div>
    <NavBar />
    <ProfilePicture />
    <Writing />
    <Skills />
    <ConnectWithMe />
  </div>
</template>

<script>
import NavBar from "./NavBar.vue";
import ProfilePicture from "./ProfilePicture.vue";
import Writing from "./Writings.vue";
import ConnectWithMe from "./ConnectWithMe.vue";
import Skills from "./Skills.vue";

export default {
  name: "Container",
  components: {
    NavBar,
    ProfilePicture,
    Writing,
    ConnectWithMe,
    Skills,
  },
};
</script>

<style></style>
